import { Payee } from '@root/api/ump-catalog-manager'
import { countryIcons } from '@shared/config'

export const getCountriesWithIcons = (denominationsData: Payee[]) => {
  const countryVouchers = [...new Set(denominationsData.map(({ features }) => features?.country_web ?? 'noRegion'))]

  return countryVouchers.map((country) => ({
    country,
    icon: countryIcons[country as keyof typeof countryIcons] || null,
  }))
}
